import { styled } from '@mui/material/styles';

import { Box } from '../../../components/atoms/Box';

import { COLORS } from '../../../configs/colors';

export const WrapperBox = styled(Box)`
  width: 100%;
  padding: 10px;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
  margin-top: 10px;;
`;

export const ContentWrapper = styled(Box)`
  padding-bottom: 10px;
`;

export const StructureFieldsWrapper = styled(Box)`
  padding-left: 24px;
  padding-bottom: 10px;
`;